import { render, staticRenderFns } from "./CarriersEdit.vue?vue&type=template&id=6e6796f4&"
import script from "./CarriersEdit.vue?vue&type=script&lang=js&"
export * from "./CarriersEdit.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports